import { useContext } from "react";
import { ModalSimilars } from "../ModalSimilars/web";
import { useIsAuthModalShowing } from "../../../GlobalHooks/useIsAuthModalShowing";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Col, Row, Space, Typography } from "antd";
import { CheckCircleTwoTone, PhoneOutlined } from "@ant-design/icons";

type Props = {
	visible: boolean,
	onCancel: () => void,
	loading: boolean,
	owner_name: string,
	phone: string,
	property_code?: string;
	owner: any;
	width?: number;
	onClick?: () => void,
	icon?: React.ReactNode
}

export const ModalPhone = (props: Props) => {
	const { theme } = useTheme();
	const { isAuthModalShowing } = useIsAuthModalShowing();
	const { translations, country_code } = useContext(ConfigStateContext);
	let phones = [];

	if (typeof props.phone != "undefined" && props.phone) phones = props.phone.split(";");

	return (
		<ModalSimilars
			visible={props.visible && !isAuthModalShowing}
			onCancel={() => props.onCancel()}
		>
			<Row
				className={"modal-phone-content"}
				justify={"center"}
				style={{ textAlign: "center" }}
				gutter={[0, theme.spacing.xsSpacing]}>
				<Col span={24}>
					<CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "25px" }} />
				</Col>
				<Col span={24}>
					<Typography.Text strong>
						{`¡No pierdas tiempo y ${translations.llama} ahora!`}
					</Typography.Text>
				</Col>
				{country_code !== "CO" && <Col span={24}>
					<Typography.Text strong>{props.loading ? "loading" : props.owner_name}</Typography.Text>
				</Col>}
				<Col span={24}>
					<Row gutter={theme.spacing.lgSpacing} justify={"center"}>
						{phones.map((p, i) => (
							<Col key={"phone_" + i}>
								<a href={"tel:" + p} onClick={props.onClick}>
									<Space size={theme.spacing.xsSpacing}>
										<PhoneOutlined style={{ color: theme.colors.linkColor }} />
										<Typography.Text style={{ color: theme.colors.linkColor }}>
											{props.loading ? "loading" : p}
										</Typography.Text>
									</Space>
								</a>
							</Col>
						))}
					</Row>
				</Col>
			</Row>
		</ModalSimilars>
	);
};


